import { render, staticRenderFns } from "./consumption.vue?vue&type=template&id=9cf1d8c2&scoped=true&"
import script from "./consumption.vue?vue&type=script&lang=js&"
export * from "./consumption.vue?vue&type=script&lang=js&"
import style0 from "./consumption.vue?vue&type=style&index=0&id=9cf1d8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf1d8c2",
  null
  
)

export default component.exports